$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('laboratory-power-3')) {
    customElements.define(
      'laboratory-power-3',
      class ProductForm extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }

        init() {
          const $icon = $('.laboratory-power-3_icon');
          const $desc = $('.laboratory-power-3_desc');
          const $mask = $('.laboratory-power-3_mask');
          const $wrapper = $('.laboratory-power-3_desc_wrapper');
          let iconDefaultStatus = false;

          $icon.on('click', function () {
            if (!iconDefaultStatus) {
              iconDefaultStatus = true;
              $mask.removeClass('top-[2.56rem] laboratory-power-3_mask_lg').addClass('bottom-[-2.5rem]');
              $icon.addClass('rotate-180');
              $wrapper.removeClass('max-xs:h-[4.63rem]').addClass('h-[auto]');
              $desc.removeClass('overflow-hidden').addClass('h-[auto]');
            } else {
              iconDefaultStatus = false;
              $mask.addClass('top-[2.56rem] laboratory-power-3_mask_lg').removeClass('bottom-[-2.5rem]');
              $icon.removeClass('rotate-180');
              $wrapper.addClass('max-xs:h-[4.63rem]').removeClass('h-[auto]');
              $desc.addClass('overflow-hidden').removeClass('h-[auto]');
            }
          });
        }
      }
    );
  }
});
